export const StatPill = ({ label, value }) => (
  <div className="rounded-2xl border border-white/10 bg-base-200/30 px-4 py-3">
    <div className="text-xs uppercase tracking-wide text-base-content/60">{label}</div>
    <div className="mt-1 text-lg font-semibold">{value}</div>
  </div>
);
